<template>
    <div class="md:w-64 bg-grey-lighter py-8">
        <slot></slot>
    </div>
</template>

<script>
export default {
    
    data() {
        return {

        }
    },

    mounted() {

    },

    methods: {
        

    },

}
</script>
